<template>
  <v-container text-xs-center>
    <v-layout row wrap>
      <v-flex xs12>
        <h3 class="font-weight-medium font-italic">[…] Kto dostrzega w sobie tę Bożą iskrę, którą jest powołanie artystyczne – powołanie poety, pisarza, malarza, rzeźbiarza, architekta, muzyka, aktora… – odkrywa zarazem pewną powinność: nie można zmarnować tego talentu, ale trzeba go rozwijać, ażeby nim służyć bliźniemu i całej ludzkości. […]</h3>
        <div class="text-xs-right">Jan Paweł II, List do artystów (Watykan, 4 kwietnia 1999) </div>
        <p class="mt-4">Serdecznie zapraszamy zatem wszystkich miłośników muzyki liturgicznej i kolęd, oraz tych, którzy swoim śpiewem chcą chwalić Pana Boga.  Obiecujemy niezwykle spotkanie z ludźmi, którzy pomogą nie tylko udoskonalić kunszt wokalny, ale również odkryć to co w muzyce najpiękniejsze, modlitwę. </p>
      </v-flex>
    </v-layout>
        <v-expansion-panel>
          <v-expansion-panel-content 
            v-for="(card, index) in cards"
            :key="index"
            id="panel-content"
          >
            <div slot="header">{{ card.title }}</div>
            <div class="card-text" v-html="card.text" />
          </v-expansion-panel-content>
        </v-expansion-panel>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      cards: [
        {
          title: 'DLA KOGO?',
          text: `
            Zapraszamy wszystkich. Nie trzeba być profesjonalistą ani nawet znać nut, wystarczą dobre chęci i zaangażowanie. Mogą być to członkowie zespołów, schol, chórów, kantorzy.  Wszyscy interesujący się muzyką liturgiczną lub samym śpiewem i podniesieniem swoich kwalifikacji pod okiem mistrzów. Ograniczone są tylko miejsca, niestety liczy się kolejność zgłoszeń, nie ma natomiast ograniczeń wiekowych.
            <br />Osoby niepełnoletnie prosimy by zabrały zgodę opiekuna.
            <br />Z reguły na tego typu warsztatach są osoby z całego kraju, tutaj również zapraszamy (jest możliwość załatwienia noclegów, szczegóły pod nr kontaktowym).`
        },
        {
          title: 'CEL I ZAKRES PRACY',
          text: 'Są to warsztaty obejmujące zajęciach z emisji głosu, kształcenia słuchu muzycznego, dykcji, doskonalenia techniki śpiewu. W trakcie zajęć prowadzone są ćwiczenia rozśpiewujące, praca w głosach i wspólne śpiewanie w wielogłosie.  Co najważniejsze, można doświadczyć piękna wspólnej modlitwy śpiewem.'
        },
        {
          title: 'ORGANIZATORZY',
          text: 'Organizatorem warsztatów jest parafialny Chór <strong>Κλημα</strong> (Klema) z Piasku. Wydarzenie patronatem objął Burmistrz Pszczyny Dariusz Skrobol. Partnerem jest Parafia Rzymskokatolicka p.w. Najświętszego Serca Pana Jezusa w Piasku oraz PSONI Pszczyna z siedzibą w Piasku.'
        }
      ]
    }
  }
}
</script>

<style>
.card-text {
  padding: 0 24px;
}
</style>

